import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NewProjectPageComponent } from '@components/new-project-page/new-project-page.component';
import { NewTopicPageComponent } from '@components/pages/new-topic-page/new-topic-page.component';

import { AuthLayoutComponent } from './components/account/auth-layout/auth-layout.component';
import { ChangePasswordComponent } from './components/account/change-password/change-password.component';
import { ForgotPasswordComponent } from './components/account/forgot-password/forgot-password.component';
import { LoginComponent } from './components/account/login/login.component';
import { ProfileComponent } from './components/account/profile/profile.component';
import { ProfileViewComponent } from './components/account/profile/view/view.component';
import { SignedUpComponent } from './components/account/signed-up/signed-up.component';
import { SignupComponent } from './components/account/signup/signup.component';
import { VerifyEmailComponent } from './components/account/verify-email/verify-email.component';
import { SessionWorkflowComponent } from './components/admin/session-workflow/session-workflow.component';
import { SessionsNotifEmailsComponent } from './components/admin/sessions-notif-emails/sessions-notif-emails.component';
import { AdminUserListComponent } from './components/admin/users/user-list.component';
import { HomeComponent } from './components/home/home.component';
import { LayoutComponent } from './components/layout/layout.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PeoplefinderComponent } from './components/peoplefinder/peoplefinder.component';
import { SearchComponent } from './components/search/search.component';
import { SessionDetailComponent } from './components/sessions/single/detail/detail.component';
import { IdeaDetailsComponent } from './components/sessions/single/idea/idea.component';
import { SessionsSingleComponent } from './components/sessions/single/session.component';
import { SessionsTopicsComponent } from './components/sessions/topics/topics.component';
import { TopicvizPanelComponent } from './components/topicviz-panel/topicviz-panel.component';
import { AdminGuard } from './guards/admin.guard';
import { AnonymousGuard } from './guards/anonymous.guard';
import { AuthenticationGuard } from './guards/authentication.guard';
import { CanDeactivateGuard } from './guards/can-decativate.guard';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
        canActivate: [AuthenticationGuard],
        pathMatch: 'full',
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'explore',
        component: PeoplefinderComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'topicviz',
        component: TopicvizPanelComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'profile/:id',
        component: ProfileViewComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'overview',
        component: HomeComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'topic/new',
        component: NewTopicPageComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'topics',
        component: SessionsTopicsComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'topics/:id',
        component: SessionsSingleComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'topics/:id/detail',
        component: SessionDetailComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'project/new',
        component: NewProjectPageComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'topics/:sessionId/ideas/:ideaId',
        component: IdeaDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'search',
        component: SearchComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'admin',
        component: AdminUserListComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'admin/sessions-notif-emails',
        component: SessionsNotifEmailsComponent,
        canActivate: [AdminGuard],
      },
      {
        path: 'admin/session-workflow',
        component: SessionWorkflowComponent,
        canActivate: [AdminGuard],
      },
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [AnonymousGuard],
    children: [
      {
        path: 'verify-email',
        component: VerifyEmailComponent,
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'signup',
        component: SignupComponent,
      },
      {
        path: 'signed-up',
        component: SignedUpComponent,
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'change-password/:token',
        component: ChangePasswordComponent,
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      enableTracing: false,
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
